import { useCallback } from "react";
import { useDashboardEditorContext } from "../../../../../../hook/context/editor";
import type { ResourceT } from "../../../../../../schema/resource";
import { createLayerTemplate } from "../../../Block/AddBlock/templates/layer";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";

export const useLayerUpdateEncodingCallback = () => {
  const editor = useDashboardEditorContext();
  const { block, preset } = useGUIEditorContext();

  return useCallback(
    (payload: ResourceT) => {
      if (!block) return;

      /** @description find layer where encoding slot is available. Otherwise, create a new layer */
      const availableLayer =
        block.config.layers.find(
          l => l.encoding.x.identifier.length === 0 || l.encoding.y.identifier.length === 0,
        ) || createLayerTemplate(preset);

      /** @description get layer (or new layer) index */
      const availableLayerIndex = block.config.layers.indexOf(availableLayer);

      const targetLayerIndex =
        availableLayerIndex === -1 ? block.config.layers.length : availableLayerIndex;

      /** @description get layer encoding available axis */
      const targetAxis =
        preset === "line"
          ? "y"
          : availableLayerIndex === block.config.layers.length
            ? "x"
            : Object.keys(availableLayer.encoding)
                .filter((k): k is "x" | "y" => k === "x" || k === "y")
                .find(axis => availableLayer.encoding[axis].identifier.length === 0) || "x";

      const layers = [
        ...block.config.layers,
        ...(targetLayerIndex === block.config.layers.length ? [availableLayer] : []),
      ].map((layer, i) => ({
        ...layer,
        encoding: {
          ...layer.encoding,
          ...(i === targetLayerIndex
            ? {
                ...(preset === "line"
                  ? { x: { identifier: payload.identifier, column: "date" } }
                  : {}),
                [targetAxis]: {
                  identifier: payload.identifier,
                  column: payload.column,
                  ...("quantity" in payload ? { quantity: payload.quantity } : {}),
                },
              }
            : {}),
        },
      }));

      void editor?.updateBlock({
        ...block,
        data: {
          ...block.data,
        },
        config: {
          ...block.config,
          layers,
        },
      });
    },
    [block, editor, preset],
  );
};
